import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import ar from './locales/ar.json';
import es from './locales/es.json';
import { partnerResourcesTranslations } from './partnerResources';
import { partnerMarketsTranslations } from './partnerMarkets';
import { applyDocumentLanguage, supportedLanguageCodes } from './languageConfig';

void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en, partnerResources: partnerResourcesTranslations.en, partnerMarkets: partnerMarketsTranslations.en },
            ar: { translation: ar, partnerResources: partnerResourcesTranslations.ar, partnerMarkets: partnerMarketsTranslations.ar },
            es: { translation: es, partnerResources: partnerResourcesTranslations.es, partnerMarkets: partnerMarketsTranslations.es },
        },
        fallbackLng: 'en',
        supportedLngs: supportedLanguageCodes,
        interpolation: { escapeValue: false },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
            lookupLocalStorage: 'platform_admin_lang',
        },
    });

i18n.on('languageChanged', (lng) => {
    applyDocumentLanguage(lng);
});

// Set initial direction.
const initial = i18n.language ?? 'en';
applyDocumentLanguage(initial);

export default i18n;
